var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverResponseErrorType = void 0;
var ShapeDiverResponseErrorType;
(function (ShapeDiverResponseErrorType) {
  ShapeDiverResponseErrorType["ASSERTION_ERROR"] = "SdAssertionError";
  ShapeDiverResponseErrorType["CACHE_ERROR_GENERIC"] = "SdCacheErrorGeneric";
  ShapeDiverResponseErrorType["CONNECTOR_ERROR"] = "SdConnectorError";
  ShapeDiverResponseErrorType["DATABASE_ERROR_GENERIC"] = "SdDatabaseErrorGeneric";
  ShapeDiverResponseErrorType["EMAILING_ERROR"] = "SdEmailingError";
  ShapeDiverResponseErrorType["ERROR_ENTITY_NOT_FOUND"] = "SdErrorEntityNotFound";
  ShapeDiverResponseErrorType["ERROR_FORBIDDEN"] = "SdErrorForbidden";
  ShapeDiverResponseErrorType["ERROR_GENERIC_CLIENT"] = "SdErrorGenericClient";
  ShapeDiverResponseErrorType["ERROR_GENERIC_INTERNAL"] = "SdErrorGenericInternal";
  ShapeDiverResponseErrorType["ERROR_UNAUTHORIZED"] = "SdErrorUnauthorized";
  ShapeDiverResponseErrorType["ILLEGAL_ARGUMENT_ERROR"] = "SdIllegalArgumentError";
  ShapeDiverResponseErrorType["JWT_VALIDATION_ERROR"] = "SdJwtValidationError";
  ShapeDiverResponseErrorType["MODEL_VALIDATION_ERROR"] = "SdModelValidationError";
  ShapeDiverResponseErrorType["NOT_ACCEPTABLE"] = "SdNotAcceptable";
  ShapeDiverResponseErrorType["NOT_FOUND_ERROR"] = "SdNotFoundError";
  ShapeDiverResponseErrorType["PARAMETER_VALIDATION_ERROR"] = "SdParameterValidationError";
  ShapeDiverResponseErrorType["RATE_LIMIT_ERROR_GENERIC"] = "SdRateLimitErrorGeneric";
  ShapeDiverResponseErrorType["REQUEST_TIMEOUT"] = "SdRequestTimeout";
  ShapeDiverResponseErrorType["REQUEST_VALIDATION_ERROR"] = "SdRequestValidationError";
  ShapeDiverResponseErrorType["RESOURCE_GONE_ERROR"] = "SdResourceGoneError";
  ShapeDiverResponseErrorType["SESSION_GONE_ERROR"] = "SdSessionGoneError";
  ShapeDiverResponseErrorType["SESSION_VALIDATION_ERROR"] = "SdSessionValidationError";
  ShapeDiverResponseErrorType["STORAGE_ERROR_GENERIC"] = "SdStorageErrorGeneric";
  ShapeDiverResponseErrorType["TEXTURE_URL_ERROR"] = "SdTextureUrlError";
  ShapeDiverResponseErrorType["TICKET_VALIDATION_ERROR"] = "SdTicketValidationError";
  ShapeDiverResponseErrorType["TOKEN_MISSING_ERROR"] = "SdTokenMissingError";
  ShapeDiverResponseErrorType["TRANSFORM_CONTENT_ARRAY_ERROR"] = "SdTransformContentArrayError";
  ShapeDiverResponseErrorType["UNCONFIRMED_MODEL_ERROR"] = "SdUnconfirmedModelError";
  ShapeDiverResponseErrorType["UNKNOWN"] = "";
})(ShapeDiverResponseErrorType || (exports.ShapeDiverResponseErrorType = ShapeDiverResponseErrorType = {}));
//# sourceMappingURL=SdResponseDtoError.js.map
export default exports;